<ng-container>
  <div class="profile-settings">
    <aside class="profile-settings__aside">
      <mat-nav-list role="list">
        <a mat-list-item role="listitem" 
          [routerLink]="['profile']">Настройки профиля</a>
        <!-- <a *ngIf="profile.group.name === GROUPS.PARENT" mat-list-item role="listitem"
          [routerLink]="['parent']">Настройки детей</a> -->
        <!-- <a mat-list-item role="listitem"
          [routerLink]="['/profile/bank']">Настройки логина</a> -->
        <a mat-list-item role="listitem"
          [routerLink]="['password']">Настройки пароля</a>
        <a mat-list-item role="listitem"
          [routerLink]="['notifications']">Настройки уведомлений</a>
        <!-- <a mat-list-item role="listitem"
          [routerLink]="['notifications']">Настройки уведомлений</a> -->
        <a mat-list-item role="listitem"
          [routerLink]="['email']">Настройки контактов</a>
        <!-- <a mat-list-item role="listitem"
          [routerLink]="['/profile/bank']">Настройки кошелька</a> -->
        <!-- <a mat-list-item role="listitem"
          [routerLink]="['/profile/bank']">Настройки приложения</a> -->
      </mat-nav-list>
    </aside>
    <div class="profile-settings__content">
      <router-outlet></router-outlet>
    </div>
  </div>
</ng-container>
